export const commandType = "SCHEDULE_SET_PICTURE_DISTANCE";
export const label = "Set picture distance";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [];
